import {
  HttpErrorResponse,
  HttpEvent,
  HttpInterceptorFn,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@price-management-console/auth';
import {
  APP_ENVIRONMENT,
  AppHttpError,
} from '@price-management-console/shared-ui';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const environment = inject(APP_ENVIRONMENT);
  const router = inject(Router);
  const isLocalProxyApi =
    req.url.startsWith('/api/') ||
    req.url.startsWith('/permission-api/') ||
    req.url.startsWith('/preferences-api/');

  const isApiRequest = environment.USING_ANGULAR_PROXY
    ? isLocalProxyApi
    : req.url.startsWith(environment.APIGEEX_HOST_URL);

  if (!isApiRequest) {
    return next(req);
  }

  return from(authService.getIdToken()).pipe(
    switchMap((token) => {
      const request = token
        ? req.clone({
            setHeaders: { Authorization: `Bearer ${token}` },
          })
        : req;
      return next(request);
    }),
    catchError((error) => {
      const serverErrors = [
        HttpStatusCode.InternalServerError,
        HttpStatusCode.BadGateway,
        HttpStatusCode.ServiceUnavailable,
        HttpStatusCode.GatewayTimeout,
      ];
      if (error instanceof HttpErrorResponse) {
        if (error.status === 403) {
          router.navigate(['/error', error.status]);
          (error as AppHttpError).skipErrorNotification = true;
        } else if (error.status === 401) {
          router.navigate(['/error', error.status]);
          authService.signOut();
          (error as AppHttpError).skipErrorNotification = true;
        } else if (serverErrors.includes(error.status)) {
          (error as AppHttpError).skipErrorNotification = true;
          router.navigate(['/error', '500']);
        }
      }

      return handleError(error, req);
    })
  );
};

function handleError(
  httpErrorResponse: AppHttpError,
  request: HttpRequest<any>
): Observable<HttpEvent<any>> {
  const { status, message, error, statusText, skipErrorNotification } =
    httpErrorResponse;
  console.log(httpErrorResponse);
  let errorCode: string | number | undefined = status;
  let errorDetail = message;
  const statusDescription = statusText;

  if (error) {
    const firstError = error.errors?.[0];
    if (firstError?.errorCode) {
      errorCode = firstError.errorCode;
      errorDetail = error.errors;
    } else if (error.status && error.detail) {
      errorCode = error.status;
      errorDetail = error.detail;
    }
  }

  const returnError: AppHttpError = {
    code: errorCode,
    errors: errorDetail,
    request: request.url,
    statusText: statusDescription,
    skipErrorNotification: skipErrorNotification,
    errorDetails: error,
  };

  return throwError(() => returnError);
}
